import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Connect with the Cosmos</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Begin your spiritual journey today</p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Office Information</h3>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h4>Main Branch</h4>
                <p>Money Plant High Street, SG Highway,<br />
                Ahmedabad, Gujarat 382470,<br />
                India</p>
                <p><a href="#branch-addresses" style={{textDecoration: 'none', color: 'yellow'}}>Sub Branch - Gandhinagar</a></p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <div>
                <h4>Phone</h4>
                <p>+91 8160569755<br />
                +91 9426708100</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h4>Email</h4>
                <p>info@astrovastukstar.com</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-clock"></i>
              <div>
                <h4>Consultation Hours</h4>
                <p>Monday - Saturday: 9:00 AM - 9:00 PM</p>
                <p>Sunday: Prior appointment only</p>
              </div>
            </div>
          </div>
          <div className="contact-form">
            <h3>Book Your Consultation</h3>
            <div className="form-coming-soon">
              <div className="form-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <h4>Online Booking Coming Soon!</h4>
              <p>Our online booking system is currently under development. For consultations and appointments, please call us directly.</p>
              <a href="tel:+918160569755" className="call-now-btn">
                <i className="fas fa-phone"></i>
                Call Now: +91 8160569755
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;